'use strict';

import { ReportFactory as R } from 'report/factory';

const t = R.table();

const AuditSalaryAccountReportTable = t.table([
	t.column(
		'Stores',
		t.contentWrapper({
			body: [t.content(d => R.data(d, 'workplace.name'))],
			foot: [t.content('Total')]
		}),
		300
	),
	t.column(
		'Hours',
		[t.content(d => R.data(d, 'total_hours'), 'numberSingleDecimal')],
		200,
		'number'
	),
	t.column(
		'Total',
		[t.content(d => R.data(d, 'total_pay'), 'currency')],
		200,
		'currency'
	)
]);

AuditSalaryAccountReportTable.setTitle(t.title(d => `${R.data(d, 'title')}`));
AuditSalaryAccountReportTable.setTableType('foldable');

export default AuditSalaryAccountReportTable;
